export enum DutyOfCareMembershipOptions {
  AutoRenewal = 'autoRenewal',
  SendWelcomeEmail = 'sendWelcomeEmail',
  EmailOptOut = 'emailOptout',
}
